import { dashboard } from './reducers';
export default dashboard;
